import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useCompanyUsers } from '@/services/api/hooks/companies';

import { User } from '@/services/api/commonTypes';
import { usePartnerUsers } from '@/services/api/hooks/partners';
import { FunctionComponent, Suspense } from 'react';

const ShowCustomerAgentsModal: FunctionComponent<ModalProps<{ mspId: string; customerId: string }>> = props => {
  const ShowCustomerAgents = () => {
    const mspId = props.props?.mspId;
    const customerId = props.props?.customerId;
    if (!mspId) throw new Error('Missing partner id');
    if (!customerId) throw new Error('Missing company id');

    const [mspUsers] = usePartnerUsers(mspId);
    const [companyUsers] = useCompanyUsers(mspId, customerId);

    return (
      <>
        <div className="mt-5 space-y-4">
          <h2 className="text-xl font-semibold">Customer Agents</h2>
          {companyUsers.items.map((user: User) => (
            <div className="flex justify-between space-x-3 items-center" key={user.id}>
              <div>
                <p key={user.id} className="font-medium">
                  {user.givenName} {user.surname}
                </p>

                <p>{user.email}</p>
              </div>
            </div>
          ))}
          <h2 className="text-xl font-semibold">MSP Agents</h2>
          {mspUsers.items.map((user: User) => (
            <div className="flex justify-between space-x-3 items-center" key={user.id}>
              <div>
                <p key={user.id} className="font-medium">
                  {user.givenName} {user.surname}
                </p>

                <p>{user.email}</p>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Authorised Agents</h1>
        </Modal.Controls>

        <Suspense fallback={<Loading />}>
          <ShowCustomerAgents />
        </Suspense>
      </Card>
    </Modal>
  );
};

export default ShowCustomerAgentsModal;
